module.exports = __webpack_public_path__ + "img/11.de805038.png";